import DemoTemplate from "./demo_template";
import AsteriaTemplate from "./asteria_template";
import SarphosaungTemplate from "./sarphosaung_template";
import HerdotandcoTemplate from "./herdotandco_template";
import MadnestTemplate from "./madnest_template";
import CetaphilTemplate from "./cetaphilmm_template";
import TogetherTemplate from "./together_template";
import WillowTemplate from "./willow_template";
import EternalgoshTemplate from "./eternalgosh_template";
import VcareTemplate from "./vcare.template";
import TwoNineTemplate from "./29_template";
import EncoreTemplate from "./encore_template";
import PhyohandmadeTemplate from "./phyohandmade_template";
import YdnmTemplate from "./ydnm_template";
import SynergyTemplate from "./synergy_template";
import MamaMyanmarTemplate from "./mamamyanmar_template";
import NciciTemplate from "./ncici_template";
import WacolTemplate from "./wacol_template";
import BondTemplate from "./bond_template";
import CommalaxTemplate from "./commalax_template";
import NextTemplate from "./next_template";
import NotFound from "../pages/not_found";
import GreenShineTemplate from "./greenshine_template";
import greenshinelogo from "../assets/images/greenshine/green shine logo 1.png";
import asteriaLogo from "../assets/images/asteria/asteria_logo.png";
import herdotandcoLogo from "../assets/images/herdotandco/her.png";
import madnestLogo from "../assets/images/madnest/mad.png";
import demoLogo from "../assets/images/demo_logo.png";
import sarphosaungLogo from "../assets/images/sarphosaung/sarphosaung_logo.jpg";
import cetaphilLogo from "../assets/images/cetaphilmm/cetaphil_logo.png";
import togetherLogo from "../assets/images/together/toge_logo.png";
import willowLogo from "../assets/images/willow/willow_logo.jpg";
import eternalgoshLogo from "../assets/images/eternalgosh/eternalgosh_logo.jpg";
import vcareLogo from "../assets/images/vcare/vcare_logo.jpg";
import phyohandmadeLogo from "../assets/images/phyohandmade/phyologo.png";
import twonineLogo from "../assets/images/29/29_logo.png";
import encoreLogo from "../assets/images/encore/en_logo.png";
import ydnmLogo from "../assets/images/ydnm/ydnm_logo.png";
import synergyLogo from "../assets/images/synergy/synergy_logo.jpg";
import mamaLogo from "../assets/images/mamamyanmar/logo.png";
import nciciLogo from "../assets/images/ncici/ncici_logo.png";
import wacolLogo from "../assets/images/wacol/logo.png";
import bondLogo from "../assets/images/bond/bond_logo.png";
import CommalaxLogo from "../assets/images/commalax/logo.png";
import LourveLogo from "../assets/images/lourve/logo.jpg";
import fitbaeLogo from "../assets/images/fitbae/fitbaelog.jpg";
import NextLogo from "../assets/images/next/logo.png";
import myanitureLogo from "../assets/images/myaniture/326391513_912063713158960_7875183330785571306_n.jpg";
import whiskyLogo from "../assets/images/whiky_house/351334625_725651462902760_8372993541499955435_n.jpg";
import NccLogo from "../assets/images/ncici/ncici_logo.png";
import ChiLogo from "../assets/images/chi/Symbol Black_CHI.png";
import RIYLogo from "../assets/images/rockinyangon/IMG_3860.png";
import LemonLogo from "../assets/images/lemon/371776777_242200888790517_936034044549931900_n.jpg";

import OsportwearsLogo from "../assets/images/osportwears/IMG_2302.jpg";
import SkinefitLogo from "../assets/images/skinefit/Skinnefit.jpg";

import TemplateSelector from "../pages/template_selector";
import { daisyUIThemes } from "../constants/dasyui_themes";
import NextgadgetTemplate from "./nextgadget_template";
import CommalaxV2Template from "./commalax_v2_template";
import LourveTemplate from "./lourve_template";
import FitBaeTemplate from "./fit_bae";

import WhiskyHouseTemplate from "./whisky_house_template";
import MyanitureTemplate from "./myaniture_template";
import NccTemplate from "./ncc_template";
import ChiTemplate from "./chi_template";
import MusicFestival from "./music_festival_template";
import LemonBabyTemplate from "./lemonbaby_template";
import OSportWearsTemplate from "./o_sportwears_template";
import SkinefitTemplate from "./skinefit_template";
import YourStylistTemplate from "./yourstylist_template";
import YourStylistLogo from "../assets/images/yourstylist/yourstyle (4).jpg";
import InternationalAcademyTemplate from "./InternationalAcademyTemplate";
import InternationalAcademyTemplateLogo from "../assets/images/InternationalAcademy/logo.png";
import SneakerGuysLogo from "../pages/sneakerguys/assets/logo.png";
import SneakerGuysTemplate from "./sneakerguys_template";
import ElfinStudioTemplate from "./elfinstudio_template";
import ElfinStudioLogo from "../assets/logos/elfinstudio.png";
import UrbanLogo from "../assets/images/urban/urban-logo-01.png";
import UrbanTemplate from "./urban_template";
import BeautyTreasure from "./beauty-treasure";
import beautyTreasureLogo from "../assets/images/beautytreasure/logo.png";
import commalaxLogo from "../assets/images/commalax-landing/logo.png";
import CommalaxLanding from "./commalax_landing";
import MyanWanTemplate from "./myan_wan_template";
import myanwanLogo from "../assets/images/myanwan/logo.png";
const templates = {
  demo: "demo",
  asteria: "asteria",
  sarphosaung: "sarphosaung",
  herdotandco: "herdotandco",
  cetaphilmm: "cetaphilmm",
  madnest: "madnest",
  together: "together",
  willow: "willow",
  eternalgosh: "eternalgosh",
  phtohandmade: "phyohandmade",
  vcare: "vcare",
  encore: "encore",
  phyohandmade: "phyohandmade",
  twonine: "29jewellery",
  ydnm: "ydnm",
  synergy: "synergy",
  mamamyanmar: "mamamyanmar",
  ncici: "ncici",
  wacol: "wacol",
  bond: "bond",
  commalax: "commalax",
  next: "next",
  selector: "selector",
  commalax_v2: "commalax_v2",
  whisky_house: "whisky_house",
  greenshine: "greenshine",
  ncc: "ncici",
  chi: "chi",
  urban: "urban",
  beauty_treasure: "beauty_treasure",
  myanwan: "myanwen",
};

const _templates = [
  {
    id: "demo",
    component: DemoTemplate,
    logo: demoLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "asteria",
    component: AsteriaTemplate,
    logo: asteriaLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "sarphosaung",
    component: SarphosaungTemplate,
    logo: sarphosaungLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "herdotandco",
    component: HerdotandcoTemplate,
    logo: herdotandcoLogo,
    isTemplate: true,
    theme: daisyUIThemes.wireframe,
  },
  {
    id: "madnest",
    component: MadnestTemplate,
    logo: madnestLogo,
    isTemplate: true,
    theme: daisyUIThemes.black,
  },
  {
    id: "cetaphilmm",
    component: CetaphilTemplate,
    logo: cetaphilLogo,
    isTemplate: true,
    theme: daisyUIThemes.corporate,
  },
  {
    id: "together",
    component: TogetherTemplate,
    logo: togetherLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "willow",
    component: WillowTemplate,
    logo: willowLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "eternalgosh",
    component: EternalgoshTemplate,
    logo: eternalgoshLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "vcare",
    component: VcareTemplate,
    logo: vcareLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "encore",
    component: EncoreTemplate,
    logo: encoreLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "phyohandmade",
    component: PhyohandmadeTemplate,
    logo: phyohandmadeLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "29jewellery",
    component: TwoNineTemplate,
    logo: twonineLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "ydnm",
    component: YdnmTemplate,
    logo: ydnmLogo,
    isTemplate: true,
    theme: daisyUIThemes.dark,
  },
  {
    id: "synergy",
    component: SynergyTemplate,
    logo: synergyLogo,
    isTemplate: true,
    theme: daisyUIThemes.cmyk,
  },
  {
    id: "mamamyanmar",
    component: MamaMyanmarTemplate,
    logo: mamaLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "ncici",
    component: NciciTemplate,
    logo: nciciLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "wacol",
    component: WacolTemplate,
    logo: wacolLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "bondmm",
    component: BondTemplate,
    logo: bondLogo,
    isTemplate: true,
    theme: daisyUIThemes.black,
  },
  {
    id: "next",
    component: NextTemplate,
    logo: NextLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "selector",
    component: TemplateSelector,
    logo: demoLogo,
    isTemplate: false,
    theme: daisyUIThemes.lofi,
  },

  {
    id: "commalax",
    component: CommalaxTemplate,
    logo: CommalaxLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "nextgadget",
    component: NextgadgetTemplate,
    logo: NextLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "commalax_v2",
    component: CommalaxV2Template,
    logo: CommalaxLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "lourve",
    component: LourveTemplate,
    logo: LourveLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "fitbae",
    component: FitBaeTemplate,
    logo: fitbaeLogo,
    isTemplate: true,
    theme: daisyUIThemes.lofi,
  },
  {
    id: "whiskyhouse",
    component: WhiskyHouseTemplate,
    logo: whiskyLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "myaniture",
    component: MyanitureTemplate,
    logo: myanitureLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "greenshine",
    component: GreenShineTemplate,
    logo: greenshinelogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "ncc",
    component: NccTemplate,
    logo: NccLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "chi",
    component: ChiTemplate,
    logo: ChiLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Rock In Yangon",
    component: MusicFestival,
    logo: RIYLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Lemon Baby",
    component: LemonBabyTemplate,
    logo: LemonLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "O Sportswear ",
    component: OSportWearsTemplate,
    logo: OsportwearsLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Skinefit",
    component: SkinefitTemplate,
    logo: SkinefitLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Your Stylist",
    component: YourStylistTemplate,
    logo: YourStylistLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "International Academy School",
    component: InternationalAcademyTemplate,
    logo: InternationalAcademyTemplateLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Sneaker Guys",
    component: SneakerGuysTemplate,
    logo: SneakerGuysLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Elfin Studio",
    component: ElfinStudioTemplate,
    logo: ElfinStudioLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "urban",
    component: UrbanTemplate,
    logo: UrbanLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Beauty Treasure",
    component: BeautyTreasure,
    logo: beautyTreasureLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "Commalax Landing",
    component: CommalaxLanding,
    logo: commalaxLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
  {
    id: "myanwen",
    component: MyanWanTemplate,
    logo: myanwanLogo,
    isTemplate: true,
    theme: daisyUIThemes.light,
  },
];

const getTemplates = () => {
  return _templates.filter((tmpl) => tmpl.isTemplate);
};
const getTemplate = (id) => {
  let page = NotFound;
  const find = _templates.findIndex((t) => t.id === id);
  if (find !== -1) {
    page = _templates[find].component;
  }
  return page;
};
export { templates, getTemplates };
export default getTemplate;
